<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="layer-group"/>
          {{ $t('servicePackage') }}
        </h1>
      </div>
    </div>
    <invoice-plan-list/>
  </main>
</template>

<script>
import InvoicePlanList from "@/views/vat-invoice/InvoicePlanList.vue";

export default {
  components: {InvoicePlanList},
  data() {
    return {}
  },
  i18n: {
    messages: {
      en: {
        servicePackage: 'Service package'
      },
      vi: {
        servicePackage: 'Gói dịch vụ'
      }
    }
  },
}
</script>